import { Component, effect, ElementRef, inject, signal, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EventsStore } from '../../../core/store/pns-filters.store';

@Component({
  selector: 'dnv-searchbar',
  imports: [TranslatePipe],
  templateUrl: './searchbar.component.html',
})
export class Searchbar {
  private readonly store = inject(EventsStore);
  public readonly textSearch = signal('');

  public readonly searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');
  
  constructor() {
    effect(() => {
      this.textSearch.set(this.store.filters().textSearch ?? '');
    });
  }

  focus(): void {
    this.searchInput()?.nativeElement?.focus();
  }
  
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.textSearch.set(input.value);
    if (!input.value.trim()) {
      this.store.updateFilters({ textSearch: null });
    }
  }

  onSubmit() {
    this.store.updateFilters({ textSearch: this.textSearch().trim() || null });
  }
}
